import { ATLAS_AI_NOTE_WORKING } from '@common/constants/webSockets'
import { Action } from 'redux'
import { takeEvery, select } from 'redux-saga/effects'
import { putPromise } from '../../helpers/redux'
import { IArcNoteWorkingAction } from '../types'
import {
  listCommentary,
  listEvents,
  UPDATE_ASSIGNEE_SUCCESS,
  UPDATE_EXHIBIT_SUCCESS,
  UPDATE_SECTION_SUCCESS,
  UPDATE_STATUS_SUCCESS,
} from './actions'
import { commentary as commentarySelector, current as currentSelector } from './selectors'

interface ISuccessAction extends Action {
  data: { id?: string; analysisId?: string }
}

// When Arc finishes working a commentary thread it was @-tagged in
// (ATLAS_AI_NOTE_WORKING → isArcWorking:false), silently refetch the loaded
// analysis's commentary so Arc's reply appears without a manual reload.
//
// Same rationale as the notes-slice saga (redux/notes/sagas.ts): the viewer
// isn't a member of Arc's hidden session, so the session-scoped
// ATLAS_AI_COMPLETE commentary refetch never reaches them. Scoped to the loaded
// analysis, and only when the completed thread's anchor note is one of its
// commentaries — otherwise an unrelated Arc run would refetch this panel.
export function* refreshCommentaryOnArcComplete() {
  yield takeEvery(ATLAS_AI_NOTE_WORKING, function* (action: IArcNoteWorkingAction) {
    if (action.data?.isArcWorking) return
    const commentaryData = (yield select(commentarySelector)) as {
      commentaries?: { note?: { id?: string } }[]
    } | null
    if (!commentaryData?.commentaries?.some((c) => c.note?.id === action.data.noteId)) return
    const currentAnalysis = (yield select(currentSelector)) as { id?: string } | null
    if (!currentAnalysis?.id) return
    yield putPromise(listCommentary(currentAnalysis.id, { skipLoader: true }))
  })
}

export function* refreshEventsOnMutation() {
  yield takeEvery(
    [
      UPDATE_STATUS_SUCCESS,
      UPDATE_ASSIGNEE_SUCCESS,
      UPDATE_SECTION_SUCCESS,
      UPDATE_EXHIBIT_SUCCESS,
    ],
    function* (action: ISuccessAction) {
      const analysisId = action.data?.analysisId ?? action.data?.id
      if (analysisId) {
        yield putPromise(listEvents(analysisId))
      }
    },
  )
}
